import { css } from 'styled-components';
import { Chip } from 'common/ui/Chip/Chip';
import { Colors } from 'styles/index';

export type WorkspaceLayoutMenuChipVariant = 'default' | 'active' | 'incompatible';

export type WorkspaceLayoutMenuChipProps = {
  variant: WorkspaceLayoutMenuChipVariant;
};

const CHIP_STYLES: Record<
  WorkspaceLayoutMenuChipVariant,
  { label: string; backgroundColor: string }
> = {
  default: { label: 'Default', backgroundColor: 'transparent' },
  incompatible: { label: 'Incompatible', backgroundColor: Colors.gray5 },
  active: { label: 'Active', backgroundColor: Colors.mainBlue },
};

export function WorkspaceLayoutMenuChip({
  variant,
}: WorkspaceLayoutMenuChipProps): React.ReactNode {
  const { label, backgroundColor } = CHIP_STYLES[variant];
  const isIncompatible = variant === 'incompatible';
  const isDefault = variant === 'default';
  const borderColor = isDefault ? Colors.gray6 : 'transparent';

  return (
    <Chip
      disableOverlay
      css={css`
        cursor: ${isIncompatible ? 'not-allowed' : 'default'};
        padding: 2px 6px;
        font-size: 12px;
        height: 16px;
        &:focus,
        &:focus-visible,
        &:focus-within,
        &:hover,
        &:active {
          box-shadow: none;
          border-color: ${borderColor};
        }
        background-color: ${backgroundColor};
        border: 1px solid ${borderColor};
        color: ${isDefault ? Colors.gray8 : Colors.white};
      `}
    >
      {label}
    </Chip>
  );
}
